import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';
import type { History, Transition } from 'history';
import { useContext, useEffect } from 'react';

type ExtendNavigator = Navigator & Pick<History, 'block'>;

export function useBlocker(blocker: (tx: Transition) => void, when = true) {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) return;

    if (!(navigator as unknown as ExtendNavigator).block) {
      return;
    }

    const unblock = (navigator as unknown as ExtendNavigator)?.block((tx: Transition) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock();
          tx.retry();
        },
      };

      blocker(autoUnblockingTx);
    });

    return unblock;
  }, [navigator, blocker, when]);
}
